import messageManagement from './message-management'


export default {
    messageManagement
}